module.exports = __webpack_public_path__ + "static/media/ChevronDownIcon.f8324ae4.svg";